// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__w4Fkz","fileBtn":"File_fileBtn__2WZ4S","closeBtn":"File_closeBtn__2QjXD","fileSelected":"File_fileSelected__3XAxI","disabled":"File_disabled__3LQw7"};